import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { AssessmentStageBuilder } from './assessment-stage-builder.component';
import { IFormOption } from '../../_core/_ui/forms.component';
import { DEFAULT_CONFIGS } from '../assessment-stage.constants';

interface IAssessmentStageBuilderContainer {
  stages: IAssessmentStage[];
  drillOptions: IFormOption[];
  practicePlanOptions: IFormOption[];
  ageGroups: IAgeGroup[];
  positionOptions: IFormOption[];
  setAgeGroupId: Function;
  ageGroup?: IAgeGroup | null;
  companyId: string;
  completeStage: Function;
  createStage: Function;
  updateStage: Function;
  removeStage: Function;
  moveStage: (stage: IAssessmentStage, direction: 'UP' | 'DOWN') => Promise<void>;
  isChangingStructure: boolean;
  structureError: string;
  fetchError: boolean;
  loading: boolean;
  onOpenUseTemplate: () => void;
}

export const AssessmentStageBuilderContainer: React.FC<IAssessmentStageBuilderContainer> = ({
  stages,
  drillOptions,
  practicePlanOptions,
  ageGroups,
  positionOptions,
  setAgeGroupId,
  ageGroup,
  companyId,
  completeStage,
  createStage,
  updateStage,
  removeStage,
  moveStage,
  isChangingStructure,
  structureError,
  fetchError,
  loading,
  onOpenUseTemplate,
}) => {
  const ageGroupOptions = useMemo<IFormOption[]>(
    () => ageGroups.map(group => ({ value: group._id, label: group.name })),
    [ageGroups],
  );

  const handleCreateStage = useCallback((type: string) => {
    if (ageGroup?._id) createStage({ type, order: stages.length + 1, config: DEFAULT_CONFIGS[type], ageGroupId: ageGroup._id });
  }, [ageGroup, createStage, stages.length]);

  const orderedStages = useMemo(() => _.orderBy(stages, 'order', 'asc'), [stages]);

  return (
    <AssessmentStageBuilder
      stages={orderedStages}
      drillOptions={drillOptions}
      practicePlanOptions={practicePlanOptions}
      ageGroupOptions={ageGroupOptions}
      positionOptions={positionOptions}
      setAgeGroupId={setAgeGroupId}
      ageGroup={ageGroup}
      companyId={companyId}
      completeStage={completeStage}
      createStage={handleCreateStage}
      moveStage={moveStage}
      isChangingStructure={isChangingStructure}
      structureError={structureError}
      removeStage={removeStage}
      updateStage={updateStage}
      fetchError={fetchError}
      loading={loading}
      onOpenUseTemplate={onOpenUseTemplate}
    />
  );
};
